import { isBefore, isToday, startOfToday } from 'date-fns'

export default (date?: Date | null) => {
  if (!date) {
    return false
  }
  return isBefore(date, startOfToday()) || isToday(date)
}
